function calculaPercentual(meta, realizado) {
    meta = Number(typeof meta === 'string' ? meta.replace('.', '') : meta)
    realizado = Number(typeof realizado === 'string' ? realizado.replace('.', '') : realizado)
    let acumulado = meta === 0 ? '-' : ((realizado / meta) * 100).toLocaleString("pt-BR", { maximumFractionDigits: 2 }) + '%'
    return acumulado;
}

function verificaColuna(categoria) {

    let consultoriasEPDI = [
        "Consultoria em Tecnologia",
        "Consultoria em Processos Produtivos",
        "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos",
        "Pesquisa, Desenvolvimento e Inovação",
        "Pesquisa, Desenvolvimento e Inovação de Produto",
        "Pesquisa, Desenvolvimento e Inovação de Processo",
        "Consultoria em Gestão Empresarial"
    ]

    let coluna;
    if(categoria === "Serviços Operacionais" || categoria === "Serviços Técnicos Especializados") {
        coluna = "numeroAtendimento";
    }
    else if(categoria === "Calibração") {
        coluna = "calibracoes";
    }
    else if(categoria === "Ensaios") {
        coluna = "ensaios";
    }
    else if(consultoriasEPDI.includes(categoria)) {
        coluna = "horasTecnicas";
    }

    return coluna;

}

function verificaValorTotalCategoria(linhaAtuacao, valor, tipo, { meses, mesSelecionado, mesSelecionadoRealizado, isAcumulado }) {
    let mesEscolhido = isAcumulado && tipo === 'realizado' ? mesSelecionadoRealizado : mesSelecionado
    let indiceMes = meses.indexOf(mesEscolhido)
    let coluna = verificaColuna(linhaAtuacao)
    let valorTotalColuna = 0;
    try {
        if(linhaAtuacao === "Metrologia") {
            valorTotalColuna = null
        }
        else {
            valorTotalColuna = valor[coluna][indiceMes]
        }
    } catch (error) {
        // valorTotalColuna = 0
    }
    return valorTotalColuna;
}

function retornarCategorias() {
    return [
        "Consultoria em Tecnologia",
        "Consultoria para Atendimento de Legislações, Normas e Regulamentos Técnicos",
        "Consultoria em Processos Produtivos",
        "Metrologia",
        "Ensaios",
        "Calibração",
        "Pesquisa, Desenvolvimento e Inovação",
        "Pesquisa, Desenvolvimento e Inovação de Produto",
        "Serviços Técnicos Especializados",
        "Serviços Operacionais",
    ]
}

function verificaCabecalhoAreaAtuacao(area, styles) {
    let isCabecalho = [
        "Consultoria em Tecnologia",
        "Metrologia",
        "Pesquisa, Desenvolvimento e Inovação",
        "Serviços Técnicos Especializados",
    ].includes(area)
    let valor = isCabecalho ? styles.tableColAtuacao : styles.tableCol
    let modalidade = isCabecalho ? styles.tableColModalidadesAtuacao : styles.tableColModalidades
    return [modalidade, valor]
}

export default {
    calculaPercentual,
    verificaColuna,
    verificaValorTotalCategoria,
    retornarCategorias,
    verificaCabecalhoAreaAtuacao
}
